module.exports = __webpack_public_path__ + "41727a423af915f0cca3c3fa746779f8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-6.png
// module id = 3230
// module chunks = 0